/**
 * Goods Discard APIs (Draft → Approve).
 * Uses inventory axios client — ORG-CODE resolves tenant/hospital server-side.
 */
import client from './inventory-request';
import { withStoreCreateBody, withStoreUpdateBody, getStoreActorId } from '../hooks/useStoreScope';

// API: POST /inventory/goods-discard/
export const createGoodsDiscard = (body) =>
  client.post('/inventory/goods-discard/', withStoreCreateBody(body));

// API: GET /inventory/goods-discard/
export const getGoodsDiscards = (p) =>
  client.get('/inventory/goods-discard/', p);

// API: GET /inventory/goods-discard/pending/
export const getPendingGoodsDiscards = (p) =>
  client.get('/inventory/goods-discard/pending/', p);

// API: GET /inventory/goods-discard/{id}/
export const getGoodsDiscard = (id) =>
  client.get(`/inventory/goods-discard/${id}/`);

// API: GET /inventory/goods-discard/{id}/items/
export const getGoodsDiscardItems = (id) =>
  client.get(`/inventory/goods-discard/${id}/items/`);

// API: PUT /inventory/goods-discard/{id}/
export const updateGoodsDiscard = (id, body) =>
  client.put(`/inventory/goods-discard/${id}/`, withStoreUpdateBody(body));

// API: DELETE /inventory/goods-discard/{id}/  → CANCELLED
export const cancelGoodsDiscard = (id) =>
  client.delete(`/inventory/goods-discard/${id}/`);

// API: POST /inventory/goods-discard/{id}/approve/
export const approveGoodsDiscard = (id, opts = {}) =>
  client.post(`/inventory/goods-discard/${id}/approve/`, {
    approved_by: opts.approved_by || getStoreActorId() || undefined,
  });

// API: POST /inventory/goods-discard/{id}/reject/
export const rejectGoodsDiscard = (id, opts = {}) =>
  client.post(`/inventory/goods-discard/${id}/reject/`, {
    rejected_by: opts.rejected_by || getStoreActorId() || undefined,
    rejection_reason: opts.rejection_reason || opts.reason || undefined,
  });
